import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AppSettingsService {
   // public static API_ENDPOINT = 'http://localhost:55166/api/';
   // public static MEDIA_URL = 'http://localhost:4200/assets/content/';

   private config: Object = null;

   constructor(private http: Http) {
   }

   /**
    * Use to get the data found in the second file (config file)
    */
   public getConfig(key: any) {
      return this.config[key];
   }

   /**
    * This method:
    *   a) Loads "config.json" to get the current working environment (e.g.: 'production', 'development')
    *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
    */
   public load() {
      return new Promise((resolve, reject) => {
         let request: any = null;
         request = this.http.get('assets/config/config.json');
         if (request) {
            request
               .map(res => res.json())
               .subscribe((responseData: any) => {
                  this.config = responseData;
                  resolve(true);
               });
         } else {
            console.error('Env config file "env.json" is not valid');
            resolve(true);
         }
      });
   }
}



// WEBPACK FOOTER //
// ./src/app/services/app-settings.service.ts